<div class="modal-header">
    <h3 class="modal-title" id="staticBackdropLabel">Detalle Solicitud</h3>
    <!--<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>-->
    <fa-icon [icon]="['fas', 'times']" (click)="onCloseModalR()" [size]="'lg'"></fa-icon>
</div>

<div class="modal-body">
    <form class="row g-3" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group">
            <label for="motivo" class="form-label">Motivo Rechazo</label>
            <select class="form-select" aria-label="Default select example" id="motivo" formControlName="motivo">
                <option disabled selected="true">Selecciona motivo de rechazo</option>
                <option *ngFor="let motivos of motivosLov" [value]="motivos.code">{{ motivos.code_desc }}</option>
            </select>
        </div>
        <button type="submit" class="btn btn-primary" style="background-color: #dc3545;">Rechazar</button>
    </form>
</div>